import Icon from "@material-ui/icons/AirportShuttle";
import VehicleList from "./VehicleList";
import VehicleShow from "./VehicleShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "vehicles",
  list: VehicleList,
  show: VehicleShow,
  icon: Icon,
};
